import api from "@/axios";

export default {
  findAll() {
    return api().get("terms-and-conditions");
  },
  findOne(id) {
    return api().get(`admin/terms-and-conditions/${id}`);
  },
  create(data) {
    return api().post("terms-and-conditions", data);
  },
  update(id, data) {
    return api().patch(`admin/terms-and-conditions/${id}`, data);
  },
  remove(id) {
    return api().delete(`terms-and-conditions/${id}`);
  },
};
